/**
 * goMD Provider - Self-contained audio WebSocket handler.
 * Based on wpphone/frontend/index.html reference implementation.
 * Audio WS endpoint: wss://{serverUrl}/call/{callId}/ws
 */

let audioWs = null
let audioCtx = null
let micStream = null
let micProcessor = null
let nextPlayTime = 0
let pendingPCM = []
let pendingLen = 0

function ensureAudioCtx() {
    if (!audioCtx) {
        audioCtx = new (window.AudioContext || window.webkitAudioContext)({ sampleRate: 16000 })
    }
    if (audioCtx.state === 'suspended') audioCtx.resume()
    return audioCtx
}

function startMicrophone() {
    navigator.mediaDevices.getUserMedia({
        audio: { sampleRate: 16000, channelCount: 1, echoCancellation: true, noiseSuppression: true },
    }).then(function (stream) {
        micStream = stream
        var source = audioCtx.createMediaStreamSource(stream)
        micProcessor = audioCtx.createScriptProcessor(4096, 1, 1)
        micProcessor.onaudioprocess = function (e) {
            if (!audioWs || audioWs.readyState !== 1) return
            var input = e.inputBuffer.getChannelData(0)
            var pcm16 = new Int16Array(input.length)
            for (var i = 0; i < input.length; i++) {
                var s = Math.max(-1, Math.min(1, input[i]))
                pcm16[i] = s < 0 ? s * 32768 : s * 32767
            }
            audioWs.send(pcm16.buffer)
        }
        source.connect(micProcessor)
        micProcessor.connect(audioCtx.destination)
        console.log('[goMD] Microphone started')
    }).catch(function (e) {
        console.error('[goMD] Mic error:', e)
    })
}

function stopAudioInternal() {
    if (audioWs) { try { audioWs.close() } catch (e) {} audioWs = null }
    if (micProcessor) { try { micProcessor.disconnect() } catch (e) {} micProcessor = null }
    if (micStream) { micStream.getTracks().forEach(function (t) { t.stop() }); micStream = null }
    if (audioCtx) { try { audioCtx.close() } catch (e) {} audioCtx = null }
    nextPlayTime = 0
    pendingPCM = []
    pendingLen = 0
}

export function preWarm() {
    ensureAudioCtx()
    if (!micStream) {
        navigator.mediaDevices.getUserMedia({
            audio: { sampleRate: 16000, channelCount: 1, echoCancellation: true, noiseSuppression: true },
        }).then(function (stream) {
            micStream = stream
            console.log('[goMD] Mic pre-warmed')
        }).catch(function (e) {
            console.warn('[goMD] Mic prewarm error:', e)
        })
    }
}

/**
 * @param {string} serverUrl - e.g. 'https://server13.chatmix.com.br'
 * @param {string} apiId - canal/server ID (e.g. '13509')
 * @param {string} callId
 */
export function connect(serverUrl, apiId, callId) {
    if (audioWs) { try { audioWs.close() } catch (e) {} audioWs = null }
    ensureAudioCtx()

    let base = serverUrl.replace(/\/+$/, '')
    if (/^https?:\/\//.test(base)) {
        base = base.replace(/^https?:/, 'wss:')
    } else {
        base = 'wss://' + base
    }
    const wsUrl = base + '/call/' + apiId + '/' + callId + '/ws'
    console.log('[goMD] Connecting audio WS:', wsUrl)

    audioWs = new WebSocket(wsUrl)
    audioWs.binaryType = 'arraybuffer'

    audioWs.onopen = function () {
        console.log('[goMD] Audio WS connected')
        nextPlayTime = 0
        pendingPCM = []
        pendingLen = 0
        startMicrophone()
    }

    audioWs.onmessage = function (evt) {
        if (typeof evt.data === 'string') return
        if (!(evt.data instanceof ArrayBuffer) || evt.data.byteLength < 2) return

        var pcm16 = new Int16Array(evt.data)
        pendingPCM.push(pcm16)
        pendingLen += pcm16.length

        if (pendingLen >= 3200) {
            var floats = new Float32Array(pendingLen)
            var off = 0
            for (var j = 0; j < pendingPCM.length; j++) {
                var chunk = pendingPCM[j]
                for (var i = 0; i < chunk.length; i++) floats[off++] = chunk[i] / 32768.0
            }
            pendingPCM = []
            pendingLen = 0

            var buf = audioCtx.createBuffer(1, floats.length, 16000)
            buf.getChannelData(0).set(floats)
            var src = audioCtx.createBufferSource()
            src.buffer = buf
            src.connect(audioCtx.destination)

            var now = audioCtx.currentTime
            if (nextPlayTime < now) nextPlayTime = now + 0.05
            src.start(nextPlayTime)
            nextPlayTime += buf.duration
        }
    }

    audioWs.onclose = function () { console.log('[goMD] Audio WS closed') }
    audioWs.onerror = function (e) { console.error('[goMD] Audio WS error', e) }
}

export function disconnect() {
    stopAudioInternal()
}

export function isConnected() {
    return audioWs !== null && audioWs.readyState === WebSocket.OPEN
}
